//eslint-disable
import React from 'react';
import { Nav, NavItem } from 'reactstrap';
import '../layout.scss';
import preval from 'preval.macro'
import moment from 'moment'
//Images
import TopArrow from '../../assets/img/brand/Vector 3.svg';
import nhbLogo from '../../assets/img/brand/nhb-footer-logo.svg';
import rootsLogo from '../../assets/img/brand/roots.svg';
import CMSGLogo from '../../assets/img/brand/CMSG_Logo.png';
import BCLogo from '../../assets/img/brand/BukitChandu.png';
import CCMLogo from '../../assets/img/brand/CCM_Logo.png';
import MHCLogo from '../../assets/img/brand/MHC_Logo.png';
import NMSLogo from '../../assets/img/brand/NMS_Logo.png';
import PMLogo from '../../assets/img/brand/PM_Logo.png';
import ACMLogo from '../../assets/img/brand/ACM_Logo.png';
import BBBLogo from '../../assets/img/brand/BBB_Logo.png';
import SYSLogo from '../../assets/img/brand/SYS_Logo.png';
import IHCLogo from '../../assets/img/brand/IHC_Logo.png';
import lionLogo from '../../assets/img/brand/lion-logo.jpg';
import seoLogo from '../../assets/img/brand/BestSEORoundWhite.png';
import functionalityLogo from '../../assets/img/brand/BestFunctionalityRoundWhite.png';
import accessibilityLogo from '../../assets/img/brand/BestAccessibilityRoundWhite.png';
import accessibilityLogo2023 from '../../assets/img/brand/BestAccessibility2023.png';
import seoLogo2023 from '../../assets/img/brand/BestSEO2023.png';

//Images

function Footer() {
	const scrollTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	const dateTimeStamp = preval`module.exports = new Date()`
	const timeTodisplay = moment(dateTimeStamp).format('DD MMM YYYY h:mm A')
	return (
		<React.Fragment>
			<Nav className="justify-content-center backToTop">
				<NavItem>
					<div className="linktop">
						<img src={TopArrow} alt="TopArrow" tabIndex="0" onClick={() => scrollTop()} />{' '}
						&nbsp;
						<span onClick={() => scrollTop()}>BACK TO TOP</span>
					</div>
				</NavItem>
			</Nav>
			<div className="container">
				{/**<div className="footerone">
					<a href="https://www.nhb.gov.sg/" target="_blank" rel="noopener noreferrer">
						<img
							style={{ width: 125 }}
							src={nhbLogo}
							alt="NHB logo"
							tabIndex="0"
							className="logo"
						/></a>
					<a href="https://www.roots.gov.sg" target="_blank" rel="noopener noreferrer">
						<img
							style={{ width: 125, marginLeft: 40 }}
							src={rootsLogo}
							alt="Roots logo"
							tabIndex="0"
							className="logo"
						/></a>
				</div>**/}
				<div className="footerone">
				<Nav className="justify-content-center justify-content-md-center ">
					<NavItem className="footer-nav-item">
						<img src={lionLogo} alt="logo" />
						<div className="awardlogos">
							<img src={accessibilityLogo2023} className='awardLogo' alt='Best Accessibility' />
							<img src={seoLogo2023} className='awardLogo' alt='Best SEO' />
							<img src={seoLogo2023} className='awardLogo' alt='Best SEO' />
						</div>
					</NavItem>
					</Nav>
					</div>
				<p className="footertwo fw-4">
					The National Heritage Board owns and operates the following museums, interpretative centres, heritage institutions and precincts.
				</p>
				<div className="footerthree">
					<ul className="p-0">
						<li className="footerimage">
							<a href='https://acm.org.sg/' target="_blank" rel="noopener noreferrer">
								<img src={ACMLogo} alt="logo" tabIndex="0" style={{width:'107px',height:'43px'}}/></a>
						</li>
						<li className="footerimage">
							<a href='https://brasbasahbugis.sg/' target="_blank" rel="noopener noreferrer">
								<img src={BBBLogo} alt="logo" tabIndex="0" style={{width:'59px',height:'43px'}}/></a>
						</li>
						<li className="footerimage">
							<a href='https://changichapelmuseum.gov.sg' target="_blank" rel="noopener noreferrer">
								<img src={CCMLogo} alt="logo" tabIndex="0" style={{width:'60px',height:'43px'}}/></a>
						</li>
						<li className="footerimage">
							<a href='https://www.nhb.gov.sg/childrensmuseum' target="_blank" rel="noopener noreferrer">
								<img src={CMSGLogo} alt="logo" tabIndex="0" style={{width:'80px',height:'43px'}}/></a>
						</li>
						<li className="footerimage">
							<a href='https://indianheritage.org.sg/' target="_blank" rel="noopener noreferrer">
								<img src={IHCLogo} alt="logo" tabIndex="0" style={{width:'70px',height:'43px'}}/></a>
						</li>
						<li className="footerimage">
							<a href='https://malayheritage.org.sg/' target="_blank" rel="noopener noreferrer">
								<img src={MHCLogo} alt="logo" tabIndex="0" style={{width:'88px',height:'43px'}}/></a>
						</li>
						<li className="footerimage">
							<a href='https://nationalmuseum.sg/' target="_blank" rel="noopener noreferrer">
								<img src={NMSLogo} alt="logo" tabIndex="0" style={{width:'87px',height:'43px'}}/></a>
						</li>
						<li className="footerimage">
							<a href='https://peranakanmuseum.org.sg/' target="_blank" rel="noopener noreferrer">
								<img src={PMLogo} alt="logo" tabIndex="0" style={{width:'86px',height:'43px'}}/></a>
						</li>
						<li className="footerimage">
							<a href='https://www.nhb.gov.sg/bukitchandu' target="_blank" rel="noopener noreferrer">
								<img src={BCLogo} alt="logo" tabIndex="0" style={{width:'92px',height:'43px'}}/></a>
						</li>						
						<li className="footerimage">
							<a href='https://sysnmh.org.sg/' target="_blank" rel="noopener noreferrer">
								<img src={SYSLogo} alt="logo" tabIndex="0" style={{width:'58px',height:'43px'}}/></a>
						</li>
					</ul>
				</div>
				<div className="footerfour d-none">
					<p className="legendtext text-uppercase">National Heritage Board</p>
					<Nav className="d-md-block listone">
						<NavItem>
							<span className="nav-link fw-6">
								Our Location
							</span>
							<span className="nav-link playfairText">
								61 Stamford Rd, #03-08,
							</span>
							<span className="nav-link playfairText">
								Singapore 178892
							</span>
						</NavItem>
					</Nav>
					<Nav className="d-md-block listTwo">
						<NavItem>
							<span className="nav-link fw-6">
								Contact Us
							</span>
							<span className="nav-link playfairText">
							NHB_Digital_Services@nhb.gov.sg
							</span>
						</NavItem>
					</Nav>
				</div>

				<div className="row">
					<div className="col-lg-4 col-md-12">
						<div className="footerfourMobile d-block">
							<div className="pl-3 mb-3 "><a href="https://www.nhb.gov.sg/who-we-are" target="_blank" rel="noopener noreferrer" className="navlink fw-5"><span>Who We Are</span></a></div>

							<ul className="justify-content-sm-start justify-content-md-end ">
								<li><a href="http://www.nhb.gov.sg/who-we-are/about-us" className="navlink fw-5" target="_blank" rel="noopener noreferrer"><span>About Us</span></a></li>
								<li><a href="http://www.nhb.gov.sg/who-we-are/media-centre" className="navlink fw-5" target="_blank" rel="noopener noreferrer"><span>Media Centre</span></a></li>
								<li><a href="http://www.nhb.gov.sg/who-we-are/join-us" className="navlink fw-5" target="_blank" rel="noopener noreferrer"><span>A Career in Heritage & Culture</span></a></li>
							</ul>
						</div>
					</div>
					<div className="col-lg-4 col-md-12">
						<div className="footerfiveMobile  d-block">
							<div className="pl-3 mb-3 "><a href="https://www.nhb.gov.sg/what-we-do" target="_blank" rel="noopener noreferrer" className="navlink fw-5"><span>What We Do</span></a></div>
							<ul>
								<li><a href="http://www.nhb.gov.sg/what-we-do/preservation" className="navlink fw-5"><span>Preserve Our Stories,Treasures & Places</span></a></li>
								<li><a href="http://www.nhb.gov.sg/what-we-do/community-engagement" className="navlink fw-5"><span>Engage Our Community</span></a></li>
								<li><a href="http://www.nhb.gov.sg/what-we-do/enrich-our-heritage-landscape" className="navlink fw-5"><span>Enrich Our Heritage Landscape</span></a></li>
							</ul>
						</div>
					</div>
					<div className="col-lg-4 col-md-12">
						<div className="footerSixMobile  d-block">
							<div className="pl-3 mb-3">
								<a href="https://www.nhb.gov.sg/heritage-plan" target="_blank" rel="noopener noreferrer" className="navlink fw-5"><span>Our SG Heritage Plan</span></a>
							</div>
						</div>
					</div>
				</div>
				{/**<div className="footerfive  mb-4 mr-3">
					<Nav className="justify-content-sm-start justify-content-md-end ">
						<NavItem className="footer-nav-item">
							<img src={lionLogo} alt="logo" />
							<div className="awardlogos">
								<img src={accessibilityLogo2023} className='awardLogo' alt='Best Accessibility' />
								<img src={seoLogo2023} className='awardLogo' alt='Best SEO' />
								<img src={seoLogo2023} className='awardLogo' alt='Best SEO' />
							</div>
						</NavItem>
					</Nav>
				</div>**/}
				<div className="footerfive">
					<Nav className="justify-content-sm-start justify-content-md-end ">
						<NavItem>
							<a href="https://www.nhb.gov.sg/contact-us" className="navlink fw-5" target="_blank" rel="noopener noreferrer">
								<span>Contact</span>
							</a>
							<a href="https://www.nhb.gov.sg/feedback" className="navlink fw-5" target="_blank" rel="noopener noreferrer">
								<span>Feedback</span>
							</a>
						{/* 	<a href="http://www.ifaq.gov.sg/NHB/apps/fcd_faqmain.aspx" className="navlink fw-5" target="_blank" rel="noopener noreferrer">
								<span>FAQ</span>
							</a> */}

							<div className="follow_us fs-16">
								<span className='fw-5'>Follow us:</span>
								<a href="https://www.youtube.com/c/HeritageTV/featured"
									target="_blank" rel="noopener noreferrer"
									aria-label="Youtube">
									<i className="fa fa-youtube-play fa"></i>
								</a>
								<a href="https://www.facebook.com/NationalHeritageBoardSG/"
									target="_blank" rel="noopener noreferrer"
									aria-label="Facebook">
									<i className="fa fa-facebook"></i>
								</a>
								<a href="https://www.instagram.com/nhb_sg/"
									target="_blank" rel="noopener noreferrer"
									aria-label="Instagram">
									<i className="fa fa-instagram"></i>
								</a>
							</div>
						</NavItem>
					</Nav>
				</div>
				<div className="footerbottom">
					<Nav>
						<NavItem>
							<a href="https://www.tech.gov.sg/report_vulnerability" target="_blank" rel="noopener noreferrer" className="navlink fw-5">
								<span>Report Vulnerability</span>
							</a>
							<a href="https://www.nhb.gov.sg/contents/privacy-policy" target="_blank" rel="noopener noreferrer" className="navlink fw-5">
								<span>Privacy Statement</span>
							</a>
							<a href="https://www.nhb.gov.sg/contents/terms-of-use" target="_blank" rel="noopener noreferrer" className="navlink fw-5">
								<span>Terms of Use</span>
							</a>
							{/* <a href="" target="_blank" rel="noopener noreferrer" className="navlink fw-5">
								<span>Sitemap</span>
							</a> */}

						</NavItem>
					</Nav>
					<ul className="footerbottomtwo fs-14 fw-5">
						<li>© {moment().year()}, Government of Singapore</li>
						<li>Last Updated on {timeTodisplay} </li>
					</ul>
				</div>
			</div>
		</React.Fragment>
	);
}

export default Footer;